import React, { useState, useEffect } from 'react';
import { getClients, getClientImages } from '../../api/services';
import './OurClients.css';

function OurClients() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [gallery, setGallery] = useState([]);
  const [galleryLoading, setGalleryLoading] = useState(false);

  useEffect(() => {
    getClients().then(res => {
      if (res.success) setClients(res.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const openClient = (client) => {
    setSelected(client);
    setGallery([]);
    setGalleryLoading(true);
    getClientImages(client.id)
      .then(res => { if (res.success) setGallery(res.data || []); })
      .finally(() => setGalleryLoading(false));
  };

  const closeClient = () => setSelected(null);

  if (loading) return (
    <section className="section clients-section">
      <div className="container">Loading...</div>
    </section>
  );

  return (
    <section className="section clients-section">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Client Works</span>
          <h2 className="section-title">Trusted by Leading Clients</h2>
          <p className="section-subtitle">Proud to work with these esteemed organizations</p>
        </div>
        <div className="clients-grid">
          {clients.length === 0
            ? <p className="no-data">No clients added yet.</p>
            : clients.map((client) => (
              <div key={client.id} className="client-item" onClick={() => openClient(client)} role="button" tabIndex={0}>
                {client.logo_url
                  ? <img src={client.logo_url} alt={client.name} className="client-logo-img" />
                  : <div className="client-logo">{client.name.charAt(0)}</div>
                }
                <span className="client-name">{client.name}</span>
              </div>
            ))
          }
        </div>
      </div>

      {selected && (
        <div className="client-modal-overlay" onClick={closeClient}>
          <div className="client-modal" onClick={e => e.stopPropagation()}>
            <button className="client-modal__close" onClick={closeClient}>✕</button>

            <div className="client-modal__header">
              {selected.logo_url
                ? <img src={selected.logo_url} alt={selected.name} className="client-modal__logo" />
                : <div className="client-logo client-modal__logo-fallback">{selected.name.charAt(0)}</div>
              }
              <div>
                <h3 className="client-modal__name">{selected.name}</h3>
                {selected.website_url && (
                  <a href={selected.website_url} target="_blank" rel="noreferrer" className="client-modal__website">
                    {selected.website_url}
                  </a>
                )}
              </div>
            </div>

            {selected.description && (
              <p className="client-modal__description">{selected.description}</p>
            )}

            {galleryLoading ? (
              <p className="client-modal__gallery-loading">Loading gallery...</p>
            ) : gallery.length > 0 && (
              <div className="client-modal__gallery">
                {gallery.map((img) => (
                  <figure key={img.id} className="client-modal__gallery-item">
                    <img src={img.image_url} alt={img.caption || selected.name} />
                    {img.caption && <figcaption>{img.caption}</figcaption>}
                  </figure>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
}

export default OurClients;